/**
 * Middleware do obsługi Google Analytics 4
 * Automatycznie śledzi ważne zdarzenia w aplikacji na podstawie akcji Redux
 */
import {
	trackUserLoginFailure,
	trackUserLoginSuccess,
} from "../../helpers/analytics";

const analyticsMiddleware = () => (next) => (action) => {
	const result = next(action);

	// Pobieramy aktualny stan po wykonaniu akcji
	// const state = store.getState();

	try {
		switch (action.type) {
			// ############### AUTH EVENTS ###############
			case "auth/login/fulfilled": {
				const userId = action.payload?.result?.id;

				trackUserLoginSuccess({
					method: "email",
					userId,
				});
				break;
			}

			case "auth/login/rejected": {
				const userId = action.payload?.result?.id;

				trackUserLoginFailure({
					userId,
				});
				break;
			}

			// ############### ERROR TRACKING ###############
			default: {
				break;
			}
		}
	} catch (error) {
		// Nie blokujemy aplikacji jeśli analytics ma problemy
		// eslint-disable-next-line no-console
		console.warn("Analytics middleware error:", error);
	}

	return result;
};

export default analyticsMiddleware;

// ############################################################
